import { nothing } from 'maybeasy';
import { LearningDesign } from '../Types/SectionTemplates';
import { ProductCollectionResource } from '../Types';

/**
 * Creates a curated product collection resource from a learning design template.
 * Curated sections are pre-populated with themed program collections.
 */
export const createCuratedSection = (
  learningDesign: LearningDesign,
): ProductCollectionResource => ({
  payload: {
    id: nothing<number>(),
    name: learningDesign.name,
    description: learningDesign.description,
    kind: 'learning-design' as const,
    display_type: 'grid',
    experiences: learningDesign.experiences,
    browse_all: false,
    learning_design_state: 'curated' as const,
    display_per_page_count: 12,
    display_button_label: nothing<string>(),
  },
  links: [],
});

/**
 * Creates multiple curated product collection resources from an array of learning design IDs.
 * Returns an array of ProductCollectionResource objects.
 */
export const createCuratedSections = (
  curatedSectionIds: number[],
  availableLearningDesigns: LearningDesign[],
): ProductCollectionResource[] => {
  return curatedSectionIds
    .map((id) => availableLearningDesigns.find((ld) => ld.id === id))
    .filter((ld): ld is LearningDesign => ld !== undefined)
    .map(createCuratedSection);
};
